import { MDBox } from "../MDBox";

interface IDataTableBodyCellProps {
  children: React.ReactNode;
  noBorder?: boolean;
  align?: "left" | "right" | "center";
  highlightCell?:  string | null;
}

export function DataTableBodyCell({
  noBorder = false,
  align = "left",
  highlightCell = null,
  children,
}: IDataTableBodyCellProps) {
  return (
    <MDBox
      component="td"
      textAlign={align}
      py={1}
      px={1.5}
      sx={({ palette: { light }, typography: { size }, borders: { borderWidth } } : any) => ({
        fontSize: size.sm,
        backgroundColor: highlightCell ? highlightCell : 'none',
        borderBottom: noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`,
      })}
    >
      <MDBox
        display="inline-block"
        color="text"     
        sx={{ verticalAlign: "middle" }}
      >
        {children}
      </MDBox>
    </MDBox>
  );
}
